import React, { useState, useEffect } from "react"
import CurrencyFormat from "react-currency-format"
import Styles from './styles.module.sass'

const ContentSinglePlans = (props) =>{

    const {
        singlePlanData,
        deselectMorePlans,
        selectMorePlans
    } = props

    const [isDisabled, setIsDisabled] = useState(true)
    const [viewInfo, setViewInfo] = useState(false)

    const [otherValueSP, setOtherValueSP] = useState(singlePlanData.minimum_to_pay === 0 ? "" : singlePlanData.minimum_to_pay)
    const changeOtherValue = (e) => {
        let otherPl = e.target.value
        let totalFloat
        let regE = /[^\d\.\d+]+/g
        let precioRedondo = otherPl.replace(regE,'')
        if( isNaN(precioRedondo) ){
            totalFloat = parseFloat(precioRedondo)
        }else{
            totalFloat = precioRedondo
        }
        setOtherValueSP( totalFloat )
    }

    useEffect(()=>{
        document.querySelector('.contentCardsSimplePlan input[type="radio"]').checked = true
    },[])

    useEffect(()=>{
        if(selectMorePlans){
            setIsDisabled(true)
            setViewInfo(false)
        }
    },[selectMorePlans])

    const formSimplePlan = () =>{
        let selected = document.querySelector('.contentCardsSimplePlan input[type="radio"]:checked').id
        if(document.querySelector('.cardMultiPlansSelected input[name="multiPlanSelected"]')){
            document.querySelector('.cardMultiPlansSelected input[name="multiPlanSelected"]').checked = false
            deselectMorePlans()
        }
        if(selected === "other_pay_SP"){
            setIsDisabled(false)
            setViewInfo(true)

        }else{
            setIsDisabled(true)
            setViewInfo(false)
            setOtherValueSP(singlePlanData.minimum_to_pay === 0 ? "" : singlePlanData.minimum_to_pay)
        }
    }

    return(
        <form className={`${Styles?.contentCardsSimplePlan} contentCardsSimplePlan`} onChange={formSimplePlan}>
            <div className={Styles?.cardToPay}>
                <input type="radio" id="minimum_to_pay_SP" name="singlePlan" value={singlePlanData.minimum_to_pay} data-terminal="10" />
                <label className={Styles?.typeCardView} for="minimum_to_pay_SP">
                    <CurrencyFormat
                        value={Number(singlePlanData.minimum_to_pay % 1) === 0 ? singlePlanData.minimum_to_pay + '.001' : singlePlanData.minimum_to_pay}
                        displayType={'text'}
                        decimalScale={2}
                        FixedDecimalScale={true}
                        thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                    />
                    <span>Pago minimo:</span>
                </label>
            </div>

            <div className={Styles?.cardToPay}>
                <input type="radio" id="monthly_payment_SP" name="singlePlan" value={singlePlanData.monthly_payment} data-terminal="11" />
                <label className={Styles?.typeCardView} for="monthly_payment_SP">
                    <CurrencyFormat
                        value={Number(singlePlanData.monthly_payment % 1) === 0 ? singlePlanData.monthly_payment + '.001' : singlePlanData.monthly_payment}
                        displayType={'text'}
                        decimalScale={2}
                        FixedDecimalScale={true}
                        thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                    />
                    <span>Mensualidad:</span>
                </label>
            </div>

            <div className={Styles?.cardToPay}>
                <input type="radio" id="new_balance_cutting_SP" name="singlePlan" value={singlePlanData.new_balance_cutting} data-terminal="12" />
                <label className={Styles?.typeCardView} for="new_balance_cutting_SP">
                    <CurrencyFormat
                        value={Number(singlePlanData.new_balance_cutting % 1) === 0 ? singlePlanData.new_balance_cutting + '.001' : singlePlanData.new_balance_cutting}
                        displayType={'text'}
                        decimalScale={2}
                        FixedDecimalScale={true}
                        thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                    />
                    <span>Saldo actual:</span>
                </label>
            </div>

           <div className={Styles?.cardToPay}>
                <input type="radio" id="payment_not_generate_interest_SP" name="singlePlan" value={singlePlanData.payment_not_generate_interest} data-terminal="13" />
                <label className={Styles?.typeCardView} for="payment_not_generate_interest_SP">
                    <CurrencyFormat
                        value={Number(singlePlanData.payment_not_generate_interest % 1) === 0 ? singlePlanData.payment_not_generate_interest + '.001' : singlePlanData.payment_not_generate_interest}
                        displayType={'text'}
                        decimalScale={2}
                        FixedDecimalScale={true}
                        thousandSeparator={true} prefix={'$'} renderText={value => <strong>{value} </strong>}
                    />
                    <span>Pago para no generar intereses:</span>
                </label>
            </div>


            <div className={Styles?.cardToPay}>
                <input type="radio" id="other_pay_SP" name="singlePlan" value={otherValueSP} data-terminal="14" />
                <label className={Styles?.typeCardView} for="other_pay_SP">
                    <input type="text" value={otherValueSP} onChange={changeOtherValue} className="inputLine" disabled={isDisabled} placeholder="0"/>
                    <span>Otro:</span>
                    {viewInfo &&
                        <span className={Styles?.infoMessage}>El pago sera distribuido de forma automatica entre tus planes de pago vigentes</span>
                    }
                </label>
            </div>

        </form>
    )
}

export default ContentSinglePlans;